function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "ic_change photo",
    transform: "translate(-1427 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(1427 9)",
    style: {
      fill: "#21a2ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 226.15a3.168 3.168 0 1 0 0-6.335 3.03 3.03 0 0 0-2.24.919 3.233 3.233 0 0 0 0 4.5 3.03 3.03 0 0 0 2.24.916zm-5.53 2.45a1.464 1.464 0 0 1-1.47-1.47v-8.277a1.464 1.464 0 0 1 1.47-1.47h2.135L84.882 216h4.235l1.295 1.382h2.118a1.464 1.464 0 0 1 1.47 1.47v8.277a1.464 1.464 0 0 1-1.47 1.47z",
    transform: "translate(1352 -201.3)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.7312a7e90cd843d973e890575185c76f.svg";
export { ForwardRef as ReactComponent };